import React from 'react';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './index.sass'
import HalfCover from "../../components/HalfCover";
import Waves from "../../components/Waves";
import Head from "../../components/Head";
import {MoveToTopOnMount} from "../../utils/pageScroll";
import ProjectContentContainer from "../../components/ProjectContentContainer";
import EmojiNatureIcon from '@mui/icons-material/EmojiNature';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SchoolIcon from '@mui/icons-material/School';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import MemoryIcon from '@mui/icons-material/Memory';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import CodeIcon from '@mui/icons-material/Code';
import GroupsIcon from '@mui/icons-material/Groups';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import PianoIcon from '@mui/icons-material/Piano';
import ModeIcon from '@mui/icons-material/Mode';
import YouTubeIcon from '@mui/icons-material/YouTube';


function Index() {
    return (
        <>
            <Head
                title={'More About Eurey'}
                desc={'More information about Eurey'}
            />
            <MoveToTopOnMount />

            <HalfCover />

            <Waves pos={'top'} halfCover/>

            <section id="more-timeline">
                <ProjectContentContainer>
                    <VerticalTimeline
                        layout={'1-column-left'}
                        lineColor={'white'}
                    >
                        <VerticalTimelineElement
                            date="Sept. 2021 - Present"
                            iconStyle={{ background: 'black', color: '#F1F1F1' }}
                            icon={<EmojiNatureIcon />}
                        >
                        <h2 className="vertical-timeline-element-title">HHMI Janelia Research Campus (mlvisualize)</h2>
                        <h3 className="vertical-timeline-element-subtitle">UI/UX Designer and Full-Stack Software Engineer</h3>
                        <ul>
                            <li>
                                Research Assistant under Professor Nakul Verma at Columbia and Janelia Research Campus
                            </li>
                            <li>
                                 Designing user interface and experience for biologists to visualize animal behavior
                            </li>
                            <li>
                                Visualizing large data sets of activities in populations of neurons that contribute to animal behavior
                            </li>
                            <li>
                                Outlined overall software architecture
                            </li>
                            <li>
                                Designed and developed with Figma, React frontend, and Flask backend
                            </li>
                            <li>
                                Migrated from a MATLAB software to a web app and improved speed and interactivity
                            </li>
                            <li>
                                Advised an undergraduate student
                            </li>
                        </ul>
                      </VerticalTimelineElement>

                        <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            date="Sept. 2021 - Dec. 2021"
                            iconStyle={{ background: '#5ab0ff', color: '#fff' }}
                            icon={<AccountBalanceIcon />}
                        >
                        <h2 className="vertical-timeline-element-title">Resera Capital</h2>
                        <h3 className="vertical-timeline-element-subtitle">Frontend Developer and Designer</h3>
                        <ul>
                            <li>
                                Worked at a startup making a secondary equity market trading platform
                            </li>
                            <li>
                                Implemented authentication with AWS ecosystem
                            </li>
                            <li>
                                Established design system and flow for Hi-Fi prototype on Figma
                            </li>
                            <li>
                                Developed the enterprise website for the startup considering accessibility and design trends
                            </li>
                        </ul>
                      </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2021 - Dec. 2022 Expected"
                            iconStyle={{ background: '#B9D9EB', color: '#fff' }}
                            icon={<SchoolIcon />}
                        >
                        <h2 className="vertical-timeline-element-title">Columbia University</h2>
                        <h3 className="vertical-timeline-element-subtitle">Computer Science, M.S.</h3>
                        <h4 className="vertical-timeline-element-subtitle">The Vision, Graphics, Interaction, and Robotics Track</h4>
                          <p>Relevant Coursework</p>
                        <ul>
                            <li>
                                Master's research with Prof. Nakul Verma (mlvisualize)
                            </li>
                            <li>
                                Principles of Innovation and Entrepreneurship
                            </li>
                            <li>
                                Master's research project with Prof. Garud Iyengar (Resera Capital)
                            </li>
                            <li>
                                Human-Computer Interaction
                            </li>
                            <li>
                                Advanced Web Design Studio
                            </li>
                            <li>
                                Engineering Software as a Service
                            </li>
                            <li>
                                Analysis of Algorithms I
                            </li>
                            <li>
                                3D UI and Augmented Reality
                            </li>
                        </ul>
                    </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="Jan. 2021 - Jul. 2021"
                            iconStyle={{ background: '#5E53E2', color: '#fff' }}
                            icon={<ShowChartIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Markov A.I.</h2>
                            <h3 className="vertical-timeline-element-subtitle">Frontend Developer and Designer</h3>
                            <ul>
                                <li>
                                    Worked at a startup developing options trading recommendation platform
                                </li>
                                <li>
                                    Implemented novel ways of representing information on options trading in a concise yet conveying manner in React
                                </li>
                                <li>
                                    Refactored approximately 2000 lines of code to improve performance and integrate Redux for state management and scalability
                                </li>
                                <li>
                                    Improved usability and accessibility following design trends and WCAG standards
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2020 - Present"
                            iconStyle={{ background: 'rgb(0,0,0)', color: '#fff' }}
                            icon={<HeadphonesIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Music Production</h2>
                            <ul>
                                <li>
                                    Logic Pro X
                                </li>
                                <li>
                                    Native Instruments Komplete Kontrol M32
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2020 - Present"
                            iconStyle={{ background: 'rgb(174,117,0)', color: '#fff' }}
                            icon={<MusicNoteIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Acoustic Guitar</h2>
                            <ul>
                                <li>
                                    Just started :)
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2019 - 2021"
                            iconStyle={{ background: '#B9D9EB', color: '#fff' }}
                            icon={<SchoolIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Columbia University</h2>
                            <h3 className="vertical-timeline-element-subtitle">Computer Engineering, B.S.</h3>
                            <p>Relevant Coursework</p>
                            <ul>
                                <li>
                                    User Interface Design
                                </li>
                                <li>
                                    Advanced Software Engineering
                                </li>
                                <li>
                                    Developing Accessible User Interfaces
                                </li>
                                <li>
                                    Introduction to Databases
                                </li>
                                <li>
                                    IoT - Intelligent and Connected Systems
                                </li>
                                <li>
                                    Programming Language and Translators
                                </li>
                                <li>
                                    Advanced Programming
                                </li>
                                <li>
                                    Computer Science Theory
                                </li>
                                <li>
                                    Computer Networks
                                </li>
                                <li>
                                    Advanced Logic Design
                                </li>
                                <li>
                                    Circuit Analysis + Lab
                                </li>
                                <li>
                                    Signals and Systems + Lab
                                </li>
                                <li>
                                    Electronic Circuits + Lab
                                </li>
                                <li>
                                    Fundamentals of Computer Systems + Lab
                                </li>
                                <li>
                                    Probability
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="Jun. 2019"
                            iconStyle={{ background: '#234b8d', color: '#fff' }}
                            icon={<MemoryIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Micron Memory Japan</h2>
                            <h3 className="vertical-timeline-element-subtitle">Failure Analysis Intern</h3>
                            <ul>
                                <li>
                                    Investigated memory failures in DRAM that were returned from customers
                                </li>
                                <li>
                                    Reproduced failures to check if the problem was recurring
                                </li>
                                <li>
                                    Rigorously tested DRAM in different environments
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="Jul. 2018"
                            iconStyle={{ background: '#4b84c4', color: '#fff' }}
                            icon={<PrecisionManufacturingIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">National Instruments Japan</h2>
                            <h3 className="vertical-timeline-element-subtitle">Software and Hardware Engineer Intern</h3>
                            <ul>
                                <li>
                                    Received the Bilingual Engineer scholarship
                                </li>
                                <li>
                                    Developed a product to showcase company's strength in career forums
                                </li>
                                <li>
                                    Software side was handled by NI's LabView and its Vision module to display the company profile as well as games that introduced and mimicked few of their products
                                </li>
                                <li>
                                    Hardware side was made with Lego Mindstorms and ultrasonic sensor to create a robot arm that accepts resumes and drops them off at a designated box
                                </li>
                                <li>
                                    Live demonstration can be found&nbsp;
                                    <a href={'https://drive.google.com/file/d/1U59FKCH5oq283TpZ-8DgekAybgqeowgW/view'} className={'about__info__link'}>
                                        here
                                    </a>
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="May 2018 - Jun. 2018"
                            iconStyle={{ background: 'black', color: '#fff' }}
                            icon={<BubbleChartIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">teamLab Inc.</h2>
                            <h3 className="vertical-timeline-element-subtitle">Data Science Intern at Machine Learning Team</h3>
                            <ul>
                                <li>
                                    Analyzed customer data to be used in the recommendation system
                                </li>
                                <li>
                                    Used PostgreSQL, Python, and Shell script to investigate user flow, user interaction, and user information
                                </li>
                                <li>
                                    Proposed new index to increase click through rate and the conversion rate for each of the websites
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2016 - 2019"
                            iconStyle={{ background: '#BC002D', color: '#fff' }}
                            icon={<GroupsIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Brandeis Japanese Student Association</h2>
                            <h3 className="vertical-timeline-element-subtitle">President (2018-2019), Vice President (2017-2018), Freshman Representative (2016-2017)</h3>
                            <ul>
                                <li>
                                    Improved event attendance by 300% through extensive use of SNS, personal communication, and new events
                                </li>
                                <li>
                                    Managed club funds of approximately $10,000
                                </li>
                                <li>
                                    Reorganized club structure and increased the number of board members
                                </li>
                                <li>
                                    Improved communication within board members by being inclusive and checking in daily
                                </li>
                                <li>
                                    Focused on traditional as well as modern Japanese culture
                                </li>
                                <li>
                                    Planned, managed, and held first ever culture show, J-SAI
                                </li>
                                <li>
                                    Other new events include: Natsumatsuri (Summer Festival), TEA: Taste of East Asia, Oshogatsu (Japanese New Year), Japanese Valentine's Day, Traditional Japanese Art and Culture Event, and Onigiri x Gimbap Night.
                                </li>
                                <li>
                                    Collaborated with multiple cultural clubs including Asian American, South East Asian, Cantonese, Chinese, Korean, and Taiwanese student associations, and Archery club.
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="May 2017 - Jul. 2017"
                            iconStyle={{ background: '#fe51a3', color: '#fff' }}
                            icon={<CodeIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">influ Inc.</h2>
                            <h3 className="vertical-timeline-element-subtitle">Software Engineer Intern</h3>
                            <ul>
                                <li>
                                    Worked on web applications for digital stamp rally and digital invitation card system
                                </li>
                                <li>
                                    Used Python with Flask, HTML, CSS, JavaScript to work on both frontend and backend
                                </li>
                                <li>
                                    Wrote the entire unit test and integration test for the database of the digital stamp rally application
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2016 - 2019"
                            iconStyle={{ background: 'rgb(0, 52, 120)', color: '#fff' }}
                            icon={<SchoolIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Brandeis University</h2>
                            <h3 className="vertical-timeline-element-subtitle">Computer Science, B.A.</h3>
                            <p>Relevant Coursework</p>
                            <ul>
                                <li>
                                    Operating System
                                </li>
                                <li>
                                    Practical Machine Learning
                                </li>
                                <li>
                                    Fundamentals of Artificial Intelligence
                                </li>
                                <li>
                                    Mobile Application Development
                                </li>
                                <li>
                                    Data Structures and Algorithms
                                </li>
                                <li>
                                    Differential Equations
                                </li>
                                <li>
                                    Multivariable Calculus
                                </li>
                                <li>
                                    Discrete Structures
                                </li>
                                <li>
                                    Applied Linear Algebra
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2014 - 2016"
                            iconStyle={{ background: 'rgb(70,173,55)', color: '#fff' }}
                            icon={<SportsBaseballIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Baseball Coach at Regional Baseball Club</h2>
                            <ul>
                                <li>
                                     Coached at regional baseball team of 50 elementary school students that I used to be a part of
                                </li>
                                <li>
                                    Worked with the head coach to organize practice
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2012 - Present"
                            iconStyle={{ background: '#FF0000', color: '#fff' }}
                            icon={<YouTubeIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Video Production</h2>
                            <h3 className="vertical-timeline-element-subtitle">Runs a YouTube channel</h3>
                            <ul>
                                <li>
                                    Writes script and organizes shooting schedule
                                </li>
                                <li>
                                    Final Cut Pro
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2012"
                            iconStyle={{ background: 'rgb(0,0,0)', color: '#fff' }}
                            icon={<VolunteerActivismIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Volunteering at Tohoku, Japan after the Great East Japan Earthquake</h2>
                            <ul>
                                <li>
                                     Interacted with elementary school children who had lost their homes due to the earthquake.
                                </li>
                                <li>
                                    Fundraised at University of Tokyo for the victims.
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2010 - Present"
                            iconStyle={{ background: 'rgb(255,174,34)', color: '#fff' }}
                            icon={<ModeIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Manga / Digital Artist</h2>
                            <h3 className="vertical-timeline-element-subtitle">Runs and maintains Web Manga website</h3>
                            <ul>
                                <li>
                                    Published approximately 140 pages of comic
                                </li>
                                <li>
                                    Slowly updating!
                                </li>
                                <li>
                                    HUION Kamvas Pro 16
                                </li>
                                <li>
                                    MadiBangPaint Pro
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2009 - Present"
                            iconStyle={{ background: 'rgb(197,167,35)', color: '#fff' }}
                            icon={<MusicNoteIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Trumpet</h2>
                            <h3 className="vertical-timeline-element-subtitle">Trinity Exam Grade 8</h3>
                            <ul>
                                <li>
                                    Selected as the first trumpet for the Kanto Plains Honor Band
                                </li>
                                <li>
                                    Selected for the Kanto Plains Honor Orchestra
                                </li>
                                <li>
                                    Played in Brandeis University jazz band
                                </li>
                                <li>
                                    Played in high school jazz band, jazz combo, concert band, and rock band
                                </li>
                                <li>
                                    Helped founding the first jazz combo in high school
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2009 - 2016"
                            iconStyle={{ background: 'rgb(197, 35, 40)', color: '#fff' }}
                            icon={<SchoolIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Saint Maur International School</h2>
                            <h3 className="vertical-timeline-element-subtitle">International Baccalaureate Bilingual Diploma</h3>
                            <p>Higher Level Courses</p>
                            <ul>
                                <li>
                                    Visual Arts
                                </li>
                                <li>
                                    Physics
                                </li>
                                <li>
                                    Economics
                                </li>
                                <li>
                                    Japanese A
                                </li>
                            </ul>

                            <p>Standard Level Courses</p>
                            <ul>
                                <li>
                                    English Performance and Literature
                                </li>
                                <li>
                                    Mathematics
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            date="2001 - Present"
                            iconStyle={{ background: 'rgb(0,0,0)', color: '#fff' }}
                            icon={<PianoIcon />}
                        >
                            <h2 className="vertical-timeline-element-title">Piano</h2>
                            <h3 className="vertical-timeline-element-subtitle">Trinity Exam Grade 5</h3>
                            <ul>
                                <li>
                                    Sadly not being played too often :(
                                </li>
                            </ul>
                        </VerticalTimelineElement>

                        <VerticalTimelineElement
                            iconStyle={{ background: 'rgb(174,174,174)', color: '#fff' }}
                        />
                    </VerticalTimeline>
                </ProjectContentContainer>
            </section>
        </>
    );
}

export default Index;